import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://rqtzciglkenqnvtcpbyd.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJxdHpjaWdsa2VucW52dGNwYnlkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA3MzAyMTcsImV4cCI6MjA5NjMwNjIxN30.dkYNQUipGUBW8po66BZip6O2IFmU21A7utXMty5bTuc';

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false
  }
});

export default supabase; 